import { useEffect, useState } from "react";

interface IBeforeInstallPromptEvent extends Event {
    readonly platforms: string[];
    readonly userChoice: Promise<{
        outcome: "accepted" | "dismissed";
        platform: string;
    }>;
    prompt(): Promise<void>;
}

let beforeinstallprompt: IBeforeInstallPromptEvent = null;

const ready = (e: IBeforeInstallPromptEvent) => {
    console.log("beforeinstallprompt triggered");
    e.preventDefault();
    beforeinstallprompt = e;
};

export const registerEventListener = () => {
    window.addEventListener("beforeinstallprompt", ready as any);
};

function useBeforeinstallprompt(): [
    IBeforeInstallPromptEvent | null,
    () => void
] {
    const [prompt, setPrompt] = useState<IBeforeInstallPromptEvent | null>(null);

    const promptToInstall = () => {
        if (prompt) {
            return prompt.prompt();
        }
        return Promise.reject(new Error('promptToInstall must be called after the "beforeinstallprompt" event'));
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setPrompt(beforeinstallprompt);
        }, 5000);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    return [prompt, promptToInstall];
}

export default useBeforeinstallprompt;